const context = 'app'

export const SIGN_IN = `${context}/SIGN_IN`

export const SIGN_OUT = `${context}/SIGN_OUT`

export const UPDATE_OFFSET = `${context}/UPDATE_OFFSET`

export const SET_SCREEN_SCROLL_OFFSET = `${context}/SET_SCREEN_SCROLL_OFFSET`

export const SET_CURRENT_PAGINATION_PAGE = `${context}/SET_CURRENT_PAGINATION_PAGE`
